(function() {
    angular.module('emarket.commons').directive('provinceChooser', function() {
        return {
            scope: {
                provinceChooser: '='
            },
            controller: ['$log', '$scope', '$mdDialog', '$cookies', 'ProvinceChooser', function($log, $scope, $mdDialog, $cookies, ProvinceChooser) {
                var defaultProvince = {
                    name: 'Todo el país'
                };
                var selectedProvince = ProvinceChooser.get();

                $scope.provinceChooser = selectedProvince || defaultProvince;
                $scope.openChooser = function() {
                    ProvinceChooser.open().then(function(province) {
                        if (province) {
                            $scope.provinceChooser = province;
                        } else {
                            $scope.provinceChooser = defaultProvince;
                        }
                    });
                };
            }],
            link: function(scope, element) {
                element.on('click', function() {
                    scope.openChooser();
                });
            }
        };
    });
}());
